import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/site/Reveal";
import { STATS, MANUFACTURING_IMG } from "@/lib/site-data";

export const Manufacturing = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="manufacturing" ref={ref} className="relative overflow-hidden bg-avatar-black">
      <motion.div style={{ y: imgY }} className="absolute inset-0 h-[124%]">
        <img
          src={MANUFACTURING_IMG}
          alt="Avatar manufacturing facility"
          className="h-full w-full object-cover"
          loading="lazy"
        />
      </motion.div>
      <div className="absolute inset-0 bg-gradient-to-t from-avatar-black via-avatar-black/80 to-avatar-black/70" />

      <div className="relative z-10 mx-auto max-w-[1400px] px-6 py-28 lg:px-12 lg:py-40">
        <Reveal>
          <p className="mb-4 text-xs font-bold uppercase tracking-[0.3em] text-avatar-gold">
            (Manufacturing)
          </p>
          <h2 className="max-w-3xl font-heading text-4xl font-bold leading-none tracking-tighter text-white md:text-6xl">
            Precision at scale.<br />Consistency by design.
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-white/60">
            Careful planning and efficient execution — every tank is formed from
            100% virgin, food-grade material under ISO-certified quality control,
            then delivered on time across the region.
          </p>
        </Reveal>

        <div className="mt-20 grid grid-cols-2 gap-8 border-t border-white/15 pt-12 md:grid-cols-4">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08}>
              <div className="font-heading text-5xl font-bold tracking-tighter text-white md:text-7xl">
                {s.value}
              </div>
              <div className="mt-3 text-xs font-medium uppercase tracking-wide text-white/50">
                {s.label}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
